var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolDefs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-error",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13.344q2.188 0 3.766-1.578t1.578-3.766-1.578-3.766-3.766-1.578-3.766 1.578-1.578 3.766 1.578 3.766 3.766 1.578zM8 1.344q2.75 0 4.703 1.953t1.953 4.703-1.953 4.703-4.703 1.953-4.703-1.953-1.953-4.703 1.953-4.703 4.703-1.953zM7.344 4.656h1.313v4h-1.313v-4zM7.344 10h1.313v1.344h-1.313v-1.344z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10.781l7.063-7.063 0.938 0.938-8 8-3.719-3.719 0.938-0.938z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-add",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.656 8.656h-4v4h-1.313v-4h-4v-1.313h4v-4h1.313v4h4v1.313z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-back",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.344 7.344v1.313h-8.125l3.719 3.75-0.938 0.938-5.344-5.344 5.344-5.344 0.938 0.938-3.719 3.75h8.125z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-more",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 10.656q0.531 0 0.938 0.406t0.406 0.938-0.406 0.938-0.938 0.406-0.938-0.406-0.406-0.938 0.406-0.938 0.938-0.406zM8 6.656q0.531 0 0.938 0.406t0.406 0.938-0.406 0.938-0.938 0.406-0.938-0.406-0.406-0.938 0.406-0.938 0.938-0.406zM8 5.344q-0.531 0-0.938-0.406t-0.406-0.938 0.406-0.938 0.938-0.406 0.938 0.406 0.406 0.938-0.406 0.938-0.938 0.406z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.656 4.281l-3.719 3.719 3.719 3.719-0.938 0.938-3.719-3.719-3.719 3.719-0.938-0.938 3.719-3.719-3.719-3.719 0.938-0.938 3.719 3.719 3.719-3.719z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-delete",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.344 2.656h2.313v1.344h-9.313v-1.344h2.313l0.688-0.656h3.313zM5.344 6v6.656h5.313v-6.656h-5.313zM4 12.656v-8h8v8q0 0.531-0.406 0.938t-0.938 0.406h-5.313q-0.531 0-0.938-0.406t-0.406-0.938z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-add-list",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.344 7.656l1 1-4.656 4.688-3.031-3 1-1 2.031 2zM1.344 10.656v-1.313h5.313v1.313h-5.313zM9.344 4v1.344h-8v-1.344h8zM9.344 6.656v1.344h-8v-1.344h8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-new-list",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.344 10.656v-1.313h5.313v1.313h-5.313zM12 9.344h2.656v1.313h-2.656v2.688h-1.344v-2.688h-2.656v-1.313h2.656v-2.688h1.344v2.688zM9.344 4v1.344h-8v-1.344h8zM9.344 6.656v1.344h-8v-1.344h8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-duplicate",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.656 14v-9.344h-7.313v9.344h7.313zM12.656 3.344q0.531 0 0.938 0.391t0.406 0.922v9.344q0 0.531-0.406 0.938t-0.938 0.406h-7.313q-0.531 0-0.938-0.406t-0.406-0.938v-9.344q0-0.531 0.406-0.922t0.938-0.391h7.313zM10.656 0.656v1.344h-8v9.344h-1.313v-9.344q0-0.531 0.391-0.938t0.922-0.406h8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.813 4.688l-1.219 1.219-2.5-2.5 1.219-1.219q0.188-0.188 0.469-0.188t0.469 0.188l1.563 1.563q0.188 0.188 0.188 0.469t-0.188 0.469zM2 11.5l7.375-7.375 2.5 2.5-7.375 7.375h-2.5v-2.5z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-spinner",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8c-0.020-1.045-0.247-2.086-0.665-3.038-0.417-0.953-1.023-1.817-1.766-2.53s-1.624-1.278-2.578-1.651c-0.953-0.374-1.978-0.552-2.991-0.531-1.013 0.020-2.021 0.24-2.943 0.646-0.923 0.405-1.758 0.992-2.449 1.712s-1.237 1.574-1.597 2.497c-0.361 0.923-0.533 1.914-0.512 2.895 0.020 0.981 0.234 1.955 0.627 2.847 0.392 0.892 0.961 1.7 1.658 2.368s1.523 1.195 2.416 1.543c0.892 0.348 1.851 0.514 2.799 0.493 0.949-0.020 1.89-0.227 2.751-0.608 0.862-0.379 1.642-0.929 2.287-1.604s1.154-1.472 1.488-2.335c0.204-0.523 0.342-1.069 0.415-1.622 0.019 0.001 0.039 0.002 0.059 0.002 0.552 0 1-0.448 1-1 0-0.028-0.001-0.056-0.004-0.083h0.004zM14.411 10.655c-0.367 0.831-0.898 1.584-1.55 2.206s-1.422 1.112-2.254 1.434c-0.832 0.323-1.723 0.476-2.608 0.454-0.884-0.020-1.759-0.215-2.56-0.57-0.801-0.354-1.526-0.867-2.125-1.495s-1.071-1.371-1.38-2.173c-0.31-0.801-0.457-1.66-0.435-2.512s0.208-1.694 0.551-2.464c0.342-0.77 0.836-1.468 1.441-2.044s1.321-1.029 2.092-1.326c0.771-0.298 1.596-0.438 2.416-0.416s1.629 0.202 2.368 0.532c0.74 0.329 1.41 0.805 1.963 1.387s0.988 1.27 1.272 2.011c0.285 0.74 0.418 1.532 0.397 2.32h0.004c-0.002 0.027-0.004 0.055-0.004 0.083 0 0.516 0.39 0.94 0.892 0.994-0.097 0.544-0.258 1.075-0.481 1.578z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-down",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.938 5.719l3.063 3.063 3.063-3.063 0.938 0.938-4 4-4-4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-up",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.938 10.281l-0.938-0.938 4-4 4 4-0.938 0.938-3.063-3.063z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.656 13.344h-3.313v-5.344h-2l6.656-6 6.656 6h-2v5.344h-3.313v-4h-2.688v4z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-print",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2v2.656h-8v-2.656h8zM12.656 8q0.281 0 0.484-0.188t0.203-0.469-0.203-0.484-0.484-0.203-0.469 0.203-0.188 0.484 0.188 0.469 0.469 0.188zM10.656 12.656v-3.313h-5.313v3.313h5.313zM12.656 5.344q0.813 0 1.406 0.594t0.594 1.406v4h-2.656v2.656h-8v-2.656h-2.656v-4q0-0.813 0.594-1.406t1.406-0.594h9.313z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-export",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.656 3.344l-0.938 0.938-1.063-1.063v7.438h-1.313v-7.438l-1.063 1.063-0.938-0.938 2.656-2.688zM13.344 6.656v7.344q0 0.563-0.391 0.953t-0.953 0.391h-8q-0.563 0-0.953-0.391t-0.391-0.953v-7.344q0-0.531 0.391-0.922t0.953-0.391h2v1.313h-2v7.344h8v-7.344h-2v-1.313h2q0.563 0 0.953 0.391t0.391 0.922z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-copy",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.656 14v-9.344h-7.313v9.344h7.313zM12.656 3.344q0.531 0 0.938 0.391t0.406 0.922v9.344q0 0.531-0.406 0.938t-0.938 0.406h-7.313q-0.531 0-0.938-0.406t-0.406-0.938v-9.344q0-0.531 0.406-0.922t0.938-0.391h7.313zM10.656 0.656v1.344h-8v9.344h-1.313v-9.344q0-0.531 0.391-0.938t0.922-0.406h8z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-preview",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9q1.219 0 2.109 0.891t0.891 2.109-0.891 2.109-2.109 0.891-2.109-0.891-0.891-2.109 0.891-2.109 2.109-0.891zM12 17.016q2.063 0 3.539-1.477t1.477-3.539-1.477-3.539-3.539-1.477-3.539 1.477-1.477 3.539 1.477 3.539 3.539 1.477zM12 4.5q3.703 0 6.703 2.063t4.313 5.438q-1.313 3.375-4.313 5.438t-6.703 2.063-6.703-2.063-4.313-5.438q1.313-3.375 4.313-5.438t6.703-2.063z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-download",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.016 18h13.969v2.016h-13.969v-2.016zM18.984 9l-6.984 6.984-6.984-6.984h3.984v-6h6v6h3.984z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-import",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.016 18h13.969v2.016h-13.969v-2.016zM9 15.984v-6h-3.984l6.984-6.984 6.984 6.984h-3.984v6h-6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 16.078q1.219 0 2.063 0.867t0.844 2.039q0 1.219-0.867 2.086t-2.039 0.867-2.039-0.867-0.867-2.086q0-0.469 0.047-0.656l-7.078-4.125q-0.891 0.797-2.063 0.797-1.219 0-2.109-0.891t-0.891-2.109 0.891-2.109 2.109-0.891q1.172 0 2.063 0.797l7.031-4.078q-0.094-0.469-0.094-0.703 0-1.219 0.891-2.109t2.109-0.891 2.109 0.891 0.891 2.109-0.891 2.109-2.109 0.891q-1.125 0-2.063-0.844l-7.031 4.125q0.094 0.469 0.094 0.703t-0.094 0.703l7.125 4.125q0.844-0.75 1.969-0.75z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-about",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.016 18.984v-13.969h-10.031v13.969h10.031zM17.016 1.031q0.797 0 1.383 0.586t0.586 1.383v18q0 0.797-0.586 1.406t-1.383 0.609h-10.031q-0.797 0-1.383-0.609t-0.586-1.406v-18q0-0.797 0.586-1.406t1.383-0.609zM12.984 11.016v6h-1.969v-6h1.969zM12.984 6.984v2.016h-1.969v-2.016h1.969z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-help",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6q1.641 0 2.813 1.172t1.172 2.813q0 1.266-1.5 2.602t-1.5 2.414h-1.969q0-1.078 0.469-1.852t1.031-1.125 1.031-0.867 0.469-1.172q0-0.797-0.609-1.383t-1.406-0.586-1.406 0.586-0.609 1.383h-1.969q0-1.641 1.172-2.813t2.813-1.172zM12 20.016q3.281 0 5.648-2.367t2.367-5.648-2.367-5.648-5.648-2.367-5.648 2.367-2.367 5.648 2.367 5.648 5.648 2.367zM12 2.016q4.125 0 7.055 2.93t2.93 7.055-2.93 7.055-7.055 2.93-7.055-2.93-2.93-7.055 2.93-7.055 7.055-2.93zM11.016 18v-2.016h1.969v2.016h-1.969z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-news",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.016l8.016-5.016h-16.031zM20.016 18v-9.984l-8.016 4.969-8.016-4.969v9.984h16.031zM20.016 3.984q0.797 0 1.383 0.609t0.586 1.406v12q0 0.797-0.586 1.406t-1.383 0.609h-16.031q-0.797 0-1.383-0.609t-0.586-1.406v-12q0-0.797 0.586-1.406t1.383-0.609h16.031z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-shield",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0l-14 4-14-4c0 0-0.141 1.616 0 4l14 4.378 14-4.378c0.141-2.384 0-4 0-4zM2.256 6.097c0.75 7.834 3.547 21.007 13.744 25.903 10.197-4.896 12.995-18.069 13.744-25.903l-13.744 5.167-13.744-5.167z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-datasets",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.984 11.016v1.969h2.016v-1.969h-2.016zM2.016 14.016v-4.031h19.969v4.031h-19.969zM6 6.984v-1.969h-2.016v1.969h2.016zM2.016 3.984h19.969v4.031h-19.969v-4.031zM3.984 17.016v1.969h2.016v-1.969h-2.016zM2.016 20.016v-4.031h19.969v4.031h-19.969z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12.984v-1.969h12v1.969h-12zM3 6h18v2.016h-18v-2.016zM9.984 18v-2.016h4.031v2.016h-4.031z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.984 20.016h-4.969v-8.016h-3l9.984-9 9.984 9h-3v8.016h-4.969v-6h-4.031v6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18v2.016h-18v-2.016zM3 12.984v-1.969h18v1.969h-18zM3 18v-2.016h18v2.016h-18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDefs);
export default __webpack_public_path__ + "static/media/symbol-defs.c922dfac301e49a29e8f731fdb058096.svg";
export { ForwardRef as ReactComponent };